import { HttpErrorResponse } from '@angular/common/http';
// import { createDirectiveDefinitionMap } from '@angular/compiler/src/render3/partial/directive';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {  SortService, ResizeService, GroupService, ColumnMenuService, PageService, FilterService, ToolbarItems, EditService, ToolbarService, IEditCell, ExcelQueryCellInfoEventArgs, PdfQueryCellInfoEventArgs, ExcelExportService, PdfExportService, GridComponent  } from '@syncfusion/ej2-angular-grids';
import { ContextMenuItem, GroupSettingsModel, FilterSettingsModel, EditSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { AppConfig, APP_CONFIG } from 'src/app/app-config.module';
import { IncidentModel } from 'src/app/domain/Incident';
import { CaseManagementService } from 'src/app/service/case-management.service';
import { ClickEventArgs } from '@syncfusion/ej2-navigations'
import { EmitType} from '@syncfusion/ej2-base';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { CaseManagementIncidentTypeAddComponent } from '../case-management-incident-type-add/case-management-incident-type-add.component';
import { OrganizationService } from 'src/app/service/organization.service';
import { CaseManagementOrgTeamAddComponent } from '../case-management-org-team-add/case-management-org-team-add.component';
import { AppComponent } from 'src/app/app.component';


@Component({
  selector: 'app-case-management-org-team',
  templateUrl: './case-management-org-team.component.html',
  styleUrls: ['./case-management-org-team.component.scss'],
  providers: [SortService, GroupService, ColumnMenuService, PageService, EditService, ToolbarService,  ExcelExportService, PdfExportService]

})
export class CaseManagementOrgTeamComponent implements OnInit {

  public isVisible: boolean = false;
  public isLoading: boolean = true;
  public isModal : boolean = true;
  public showDeleteSpinner : boolean = false;

  // ------------------------------------------------------------------
  // class name of Div tag where Dialogs can be dragged around in.
  // Found in the app.component.html file.
  // ------------------------------------------------------------------
  public allowDialogDragging: Boolean = true;
  public dialogDragTarget = '.dialogDrag-section';


  public animationSettings: Object = {
    effect: 'Zoom',
    duration: 600
  };

  

  // DataGrid Settings
  public pageSettings: Object;
  public customAttributes: Object;
  public resizeSettings = { mode: "Normal" };


  records : any[];

  // --------------------------------------------------------------------
  // Used to store full single record for menu clicks
  // and show display info
  // --------------------------------------------------------------------
  currRecordLabel : string = "";
  currRecID : string = "";
  

  @ViewChild('grid')
  public grid: GridComponent;
  
  @ViewChild("componentAdd")
  componentAdd : CaseManagementOrgTeamAddComponent;


  @ViewChild("ejDialogMenu")
  ejDialogMenu : DialogComponent;

  @ViewChild("ejDialogDelete")
  ejDialogDelete: DialogComponent;


  currMenuIncident : IncidentModel = null;

  public filterSettings: FilterSettingsModel;
  public toolbar: ToolbarItems[];
  public sortOptions: object;


  filterBarTemplateForYear = {}
  
  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private caseManagementService: CaseManagementService,
    private organizationService: OrganizationService,
    private toastr: ToastrService,
    private appComponent: AppComponent,
  ) { }

  ngOnInit(): void {

    this.isLoading = false;
    this.LoadRecords();

    this.toolbar = ['ExcelExport', 'CsvExport', 'Search'];

    this.sortOptions = { columns: [{ field: 'base.unitName', direction: 'Ascending' }] };

    this.pageSettings = { pageSizes: true, pageSize: 5 };

  }


  toolbarClick(args: ClickEventArgs): void {

    switch (args.item.tooltipText) {
        case 'PDF Export':
            this.grid.pdfExport();
            break;
        case 'Excel Export':
            this.grid.excelExport();
            break;
        case 'CSV Export':
            this.grid.csvExport();
            break;
    }
}
  
  // ===================================
  // SHOW
  // ===================================
  show() {
    this.isVisible = true;

    this.LoadRecords();
  }


  LoadRecords(){


    this.organizationService.GetOrgTeams(this.appComponent.securityUtils.isServiceWorkerCacheEnabled(), this.appComponent.user.userID)
      .subscribe((result) => {

        console.log("result", result);

        this.records = result;

      },
        (error: HttpErrorResponse) => {
          console.error("ERROR --->");
          console.error(error);
          this.toastr.error("Sorry, an error occurred attempting to obtain Org Units/Teams, please contact support@forensicnotes.com", "ERROR");
        });

  }


  // ===================================
  // HIDE
  // ===================================
  hide() {
    this.isVisible = false;
    this.isLoading = true;
  }

  public onDialogClose(event: any) : void {
    this.isVisible = false;
  }

  // OpenIndexMenu(){

  //   // Get Incident
  // }

  Add(){
    this.componentAdd.SetupForNew();
    this.componentAdd.show();
  }


  refreshData(event){
    console.log("Refreshing Data");
    this.LoadRecords();
  }


  menuClick(event, record){

   
    this.currRecID = record.base.id;
    this.currRecordLabel = record.base.unitName;

    this.ejDialogMenu.show();
  }

  public onOverlayClickOutsideMenu: EmitType<object> = () => {
    this.ejDialogMenu.hide();
  };


  Edit(){

    this.ejDialogMenu.hide();


    this.componentAdd.SetupForEditing(this.currRecID, this.currRecordLabel);
    this.componentAdd.show();
  }

  Delete(){
    this.ejDialogMenu.hide();
    this.ejDialogDelete.show();
  }

  
  CancelDelete(){
    // Close
    this.ejDialogDelete.hide();
  }

  DeleteConfirmed(){

    this.showDeleteSpinner = true;


    this.organizationService.DeleteOrgTeam(this.currRecID)
    .subscribe((result) => {

      console.log("result", result);


      this.toastr.success("Org Unit/Team Deleted");
    this.showDeleteSpinner = false;

      this.ejDialogDelete.hide();
      this.refreshData(null);


    },
      (error: HttpErrorResponse) => {
        console.error("ERROR --->");
        console.error(error);
        this.toastr.error("Sorry, an error occurred attempting to Delete Org Unit/Team, please contact support@forensicnotes.com", "ERROR");
      });


  }


}
